import { createContext, useContext } from "react";

import { GMWFiltersByGMN, GMWSFilters, SelectedGmw } from "../types";

interface GmwContextType {
  selectedGmw: SelectedGmw;
  setSelectedGmw: (gmw: SelectedGmw) => void;
  gmwFilters: GMWSFilters;
  setGmwFiltersByGMN: (partial: Partial<GMWFiltersByGMN>) => void;
  setPage: (page: number) => void;
}

export const GmwContext = createContext<GmwContextType | null>(null);

export function useGmwContext() {
  const context = useContext(GmwContext);
  if (!context) throw new Error("useGmwContext must be used within GmwContext.Provider");
  return context;
}
